import { render, staticRenderFns } from "./SurveyValenceCard.vue?vue&type=template&id=21b045c4&scoped=true&"
import script from "./SurveyValenceCard.vue?vue&type=script&lang=js&"
export * from "./SurveyValenceCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b045c4",
  null
  
)

export default component.exports